module.exports = __webpack_public_path__ + "static/media/vbn-custom-2.903aaa25.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/VBN/vbn-custom-2.png
// module id = 209
// module chunks = 0